import {AvatarMenuItem} from '@coolcolduk/ui-mui';
import {useState} from 'react';
import {User} from '@cp/model';
import NavBarMobileMenuButton from './NavBarMobileMenuButton';
import NavBarMobileMenuDrawer from './NavBarMobileMenuDrawer';

export interface NavBarMobileMenuProps {
  user: User;
  navItems: AvatarMenuItem[];
  userMenu: AvatarMenuItem[];
}

export default function NavBarMobileMenu({user, navItems, userMenu}: NavBarMobileMenuProps) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleMobileMenuToggle = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  return (
    <>
      {/* Mobile Menu Button */}
      <NavBarMobileMenuButton
        handleMobileMenuToggle={handleMobileMenuToggle}
        photoUrl={user.photoUrl ?? undefined}
        displayName={user.name || ''}
      />

      <NavBarMobileMenuDrawer
        user={user}
        navItems={navItems}
        userMenu={userMenu}
        isMobileMenuOpen={isMobileMenuOpen}
        handleMobileMenuToggle={handleMobileMenuToggle}
      />
    </>
  );
}
